var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMicrosoftDefender(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "79px",
    height: "82px",
    viewBox: "0 0 79.0 82.0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440,0 L1440,1080 L0,1080 L0,0 L1440,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.11497727,0 L1.11497727,2.37681159 C0.545219697,2.37681159 0.0819924242,1.84495694 0.0819924242,1.18909473 C0.0819924242,0.531854652 0.545219697,0 1.11497727,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0825909091,0 C0.652348485,0 1.11437879,0.533232514 1.11437879,1.18909473 C1.11437879,1.84495694 0.652348485,2.37681159 0.0825909091,2.37681159 L0.0825909091,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.1962758,0 C1.8568643,0 2.39393939,0.531854652 2.39393939,1.18771687 C2.39393939,1.84495694 1.8568643,2.37681159 1.1962758,2.37681159 C0.535687308,2.37681159 0,1.84495694 0,1.18771687 C0,0.531854652 0.535687308,0 1.1962758,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.1962758,0 C1.8568643,0 2.39393939,0.531854652 2.39393939,1.18771687 C2.39393939,1.84495694 1.8568643,2.37681159 1.1962758,2.37681159 C0.535687308,2.37681159 0,1.84495694 0,1.18771687 C0,0.531854652 0.535687308,0 1.1962758,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1363636,0 C21.2288102,15.4546993 1.39566187,25.7277764 0.603898954,26.1325176 L0.579512706,26.1449275 L0,24.9540991 L0,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 C8.89214011,0 9.09921945,7.84393298 23.8125898,7.84393298 L25.1363636,9.15049728 L25.1363636,20.9156389 C25.1363636,22.7178488 24.9001398,24.4624608 24.4844472,26.1449275 L0,26.1449275 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1363636,0 L25.1363636,24.9540991 L24.5568509,26.1449275 L24.5023162,26.11705 C23.3376019,25.5175822 3.8676804,15.2969983 0,0 L25.1363636,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1363636,0 L25.1363636,26.1449275 L0.65191643,26.1449275 C0.236223836,24.4624608 0,22.7178488 0,20.9156389 L0,9.15049728 L1.32223991,7.84393298 C16.0371442,7.84393298 16.2442235,0 25.1363636,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-76.0 -640.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.0 640.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.3030303030303 51.10144927536232)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0.0819924242,0 1.11497727,0 1.11497727,2.37681159 0.0819924242,2.37681159 0.0819924242,0",
    stroke: "none",
    fill: "#2785C7"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.5 51.10144927536232)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0.0825909091,0 1.11437879,0 1.11437879,2.37681159 0.0825909091,2.37681159 0.0825909091,0",
    stroke: "none",
    fill: "#1F6FB5"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.242424242424235 8.318840579710145)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 2.39393939,0 2.39393939,2.37681159 0,2.37681159 0,0",
    stroke: "none",
    fill: "#2A94DB"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.36363636363637 8.318840579710145)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 2.39393939,0 2.39393939,2.37681159 0,2.37681159 0,0",
    stroke: "none",
    fill: "#33A8F0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.5 27.33333333333333)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 25.1363636,0 25.1363636,26.1449275 0,26.1449275 0,0",
    stroke: "none",
    fill: "#1F6A90"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.5 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i6)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 25.1363636,0 25.1363636,26.1449275 0,26.1449275 0,0",
    stroke: "none",
    fill: "#2A809D"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.363636363636372 27.33333333333333)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i7)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 25.1363636,0 25.1363636,26.1449275 0,26.1449275 0,0",
    stroke: "none",
    fill: "#278FC4"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.363636363636372 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i8)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 25.1363636,0 25.1363636,26.1449275 0,26.1449275 0,0",
    stroke: "none",
    fill: "#3BB0E3"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftDefender);
export default __webpack_public_path__ + "static/media/microsoft-defender.ac74d5da923d298ae7b2bb43ff5b1b2d.svg";
export { ForwardRef as ReactComponent };